<script setup>
import { ref, reactive, watch } from 'vue'

const props = defineProps({
  show: Boolean,
  postId: Number
})

const emit = defineEmits(['update:show', 'confirm'])

const form = reactive({
  rejectReason: ''
})
const submitting = ref(false)

watch(() => props.show, (val) => {
  if (val) {
    form.rejectReason = ''
  }
})

const handleClose = () => {
  emit('update:show', false)
}

const handleSubmit = () => {
  if (!form.rejectReason.trim()) {
    return
  }
  submitting.value = true
  emit('confirm', {
    id: props.postId,
    rejectReason: form.rejectReason.trim()
  })
}

const done = () => {
  submitting.value = false
  handleClose()
}

defineExpose({ done })
</script>

<template>
  <Teleport to="body">
    <Transition name="modal">
      <div v-if="show" class="fixed inset-0 z-50 overflow-y-auto">
        <div class="fixed inset-0 bg-black/50" @click="handleClose"></div>
        <div class="relative min-h-screen flex items-center justify-center p-4">
          <div class="relative bg-white rounded-xl shadow-2xl w-full max-w-md">
            <!-- 头部 -->
            <div class="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
              <h3 class="text-lg font-semibold text-slate-900">审核拒绝</h3>
              <button
                @click="handleClose"
                class="p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>

            <!-- 内容 -->
            <div class="p-6">
              <label class="block text-sm font-medium text-slate-700 mb-2">
                拒绝原因 <span class="text-red-500">*</span>
              </label>
              <textarea
                v-model="form.rejectReason"
                rows="4"
                placeholder="请输入拒绝原因"
                class="form-textarea"
              ></textarea>
            </div>

            <!-- 底部 -->
            <div class="px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3">
              <button
                @click="handleClose"
                class="btn-secondary"
              >
                取消
              </button>
              <button
                @click="handleSubmit"
                :disabled="submitting || !form.rejectReason.trim()"
                class="btn-danger-secondary"
              >
                {{ submitting ? '提交中...' : '确认拒绝' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
